import { Col, Row } from 'reactstrap';
import Legend from '../../GradesHistory/parts/Legends';
import { getColor } from '../../utils/getColor';
import {
  CourseEnrollmentStates,
  CourseValidationType,
} from '../types/CourseValidationType';

export interface LegendsProps {
  texts: {
    enrolled: string;
    approved: string;
    pending: string;
    failed: string;
    validated: string;
    internalValidation: string;
    proficiencyValidation: string;
    validationValidation: string;
    rap: string;
    externalValidation: string;
  };
}

export default function Legends({ texts }: LegendsProps) {
  return (
    <Row className="d-flex">
      <Col xs={6} sm="auto">
        <Legend
          label={texts.enrolled}
          color={getColor(CourseEnrollmentStates.Enrolled)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.approved}
          color={getColor(CourseEnrollmentStates.Approved)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.pending}
          color={getColor(CourseEnrollmentStates.Pending)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.failed}
          color={getColor(CourseEnrollmentStates.Reject)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.internalValidation}
          color={getColor(CourseValidationType.Internal)}
        />
      </Col>
      <Col xs={6} sm="auto">
        <Legend label={texts.rap} color={getColor(CourseValidationType.RAP)} />
      </Col>
      <Col xs={6} sm="auto">
        <Legend
          label={texts.externalValidation}
          color={getColor(CourseValidationType.External)}
        />
      </Col>
    </Row>
  );
}
